import './index.less'

import { ReactComponent as TrademarkSvg } from '@/commons/icons/project-list/tra.svg'
import { ReactComponent as ReturnSvg } from '@/commons/icons/project-list/return.svg'

import { ReactComponent as P1Svg } from '@/commons/icons/desktop-lib/p1.svg';
import { ReactComponent as P2Svg } from '@/commons/icons/desktop-lib/p2.svg';
import { ReactComponent as P3Svg } from '@/commons/icons/desktop-lib/p3.svg';
import { ReactComponent as D1Svg } from '@/commons/icons/desktop-lib/d1.svg';
import { ReactComponent as D2Svg } from '@/commons/icons/desktop-lib/d2.svg';
import { ReactComponent as D3Svg } from '@/commons/icons/desktop-lib/d3.svg';
import { ReactComponent as U1Svg } from '@/commons/icons/desktop-lib/u1.svg';
import { ReactComponent as U2Svg } from '@/commons/icons/desktop-lib/u2.svg';
import { ReactComponent as U3Svg } from '@/commons/icons/desktop-lib/u3.svg';
import { ReactComponent as PicSvg } from './icons/pic.svg';
import { LogoutOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { Route, Routes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import LibDevicePanel from './lib-device';
import ProjectList from './project-list';
import { UserFeedbackActiveBtn } from '@/commons/components/user-feedback'
import LibUserPanel from './lib-user';
import { ContextMenuFC } from 'tncet-common';
import { useEffect, useRef, useState } from 'react';
import localStore from '@/commons/store/local-store';
import { USER_TYPE } from '@/commons/enums/user';

const LIB_NAV_LIST = [
    {
        label: '项目列表',
        normalIcon: P1Svg,
        hoverIcon: P2Svg,
        activeIcon: P3Svg,
        url: '/desktop/project-list'
    },
    {
        label: '设备库',
        normalIcon: D1Svg,
        hoverIcon: D2Svg,
        activeIcon: D3Svg,
        url: '/desktop/device-list'
    },
    {
        label: '用户',
        normalIcon: U1Svg,
        hoverIcon: U2Svg,
        activeIcon: U3Svg,
        url: '/desktop/user'
    },
]

export interface IProps {
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
}

export default function DesktopLayout(props: IProps) {

    const location = useLocation();
    const navigate = useNavigate();

    const { feedbackVisible, changeFeedbackVisible } = props;

    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开菜单
    const [top, setTop] = useState<number>(); // 菜单top
    const [left, setLeft] = useState<number>(); // 菜单left
    const userRef = useRef(null);

    const logOut = () => {
        localStore.clear();
        navigate("/login");
    }

    useEffect(()=>{
        if(!localStore?.getUser()){
            navigate("/login")
        }
    },[])

    return (
        <div className="desktop-layout-container">
            <div className="head">
                <TrademarkSvg className="trademark-icon" />
                {window.history?.length > 1 && <ReturnSvg className="return-icon" onClick={() => { window.history.back() }} />}

                <div className='header-right'>
                    <UserFeedbackActiveBtn visible={feedbackVisible} changeVisible={(value) => changeFeedbackVisible(value)} />
                    <div className='user-panel' ref={userRef} onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        setCmOpen(true);
                        const rect = userRef.current.getBoundingClientRect();
                        setCmOpen(true);
                        setLeft(rect.left + 2);
                        setTop(rect.top + 26);
                    }}>
                        <PicSvg />
                        <div>{localStore.getUser()?.name || ''}</div>
                    </div>
                </div>
            </div>
            <div className='body'>
                <div className="list-title">
                    {LIB_NAV_LIST.map((item, index) => {
                        if (item.url !== '/desktop/project-list' && localStore.getUser()?.type !== USER_TYPE.ADMIN) return <></>
                        return <div className={classNames({
                            'item': true,
                            'item-active': location.pathname === item?.url
                        })} key={index} onClick={() => {
                            if (!item?.url) return;
                            navigate(item?.url);
                        }}>
                            <div className='normal-icon'><item.normalIcon /></div>
                            <div className='active-icon'><item.activeIcon /></div>
                            <div className='hover-icon'><item.hoverIcon /></div>
                            {item.label}
                        </div>
                    })}
                </div>
                <div className='list-body'>
                    <Routes>
                        <Route path="/project-list" element={<ProjectList />} />
                        <Route path="/device-list" element={<LibDevicePanel />} />
                        <Route path='/user' element={<LibUserPanel />} />
                        <Route path="*" element={<Navigate to="project-list" />} />
                    </Routes>
                </div>
            </div>

            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='device-list-right-menu'
                onCancel={() => { setCmOpen(false); }}
            >
                <div className="menu-item" onClick={logOut}><LogoutOutlined /> 退出登录</div>
            </ContextMenuFC>
        </div>
    )
}